import React from 'react'
import { Link } from "react-router-dom"
import enq from '../../Assets/enq-img.png'
const About = () => {
	return (
		<div className='about-section'>
			<div className="container-main">
				<div className="row">
					<div className="col-lg-6">
						<h1 className='about-heading montserrat'>Empowering Women, <span className='about-block-text montserrat'>Brightening Futures</span>  </h1>
						<p className='about-sub-text'>Q-Garden is more than just an institution; it's a cradle for nurturing empowered women. We believe in the transformative power of education and its ability to illuminate lives.</p>
						<div className="about-items">
							<div className="item-about">
								<p className='text-item montserrat'> <i class="ri-check-double-line blue-dark"></i> Recitation Science</p>
							</div>
							<div className="item-about">
								<p className='text-item montserrat'> <i class="ri-check-double-line green-dark"></i> Memorisation</p>
							</div>
							<div className="item-about">
								<p className='text-item montserrat'> <i class="ri-check-double-line blue-darkest"></i> Tajweed</p>
							</div>
						</div>
						<Link  className="btn enquire-btn-about" to='/about'>About us</Link>
					</div>
					<div className="col-lg-6">
							<div className="about-img-div">
									<img src={enq} className='enquiry-image' alt="" />
							</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default About










